addEventListener('DOMContentLoaded', function() {
        let swipers = [];
        
        const initSwipers = () => {
            // Destroy existing swipers
            swipers.forEach(swiper => swiper.destroy(true, true));
            swipers = [];

            // Initialize new swipers
            const swiperElements = document.querySelectorAll('.b-image-carrusel__swiper');
            swiperElements.forEach(element => {
                const root = element.closest('.b-image-carrusel');
                const nextEl = root?.querySelector('.b-image-carrusel__swiper-button-next');
                const prevEl = root?.querySelector('.b-image-carrusel__swiper-button-prev');

                const swiperConfig = {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                };

                if (nextEl && prevEl) {
                    swiperConfig.navigation = { nextEl, prevEl };
                }

                const swiper = new Swiper(element, swiperConfig);
                swipers.push(swiper);
            });
        };

        // Initialize on load
        initSwipers();





});